export const copyTranslations = {
  en: {
    title: "First names of newborns",
    intro:
      "For several decades, the Federal Statistical Office has published the first names given to newborns in Switzerland, in the cantons and in the different language regions. Every year, these first names are transmitted to the FSO by the civil registry offices together with data on the live births in that year.",
    top10header: "Top 10 first names in 2020 in ",
    top10explanation:
      "Choose a language region to see the most popular baby first names in that region.",
    languages: [
      {
        value: "CH",
        label: "Switzerland",
      },
      {
        value: "DD",
        label: "German-speaking region",
      },
      {
        value: "FF",
        label: "French-speaking region",
      },
      {
        value: "II",
        label: "Italian-speaking region",
      },
      {
        value: "RR",
        label: "Romansh-speaking region",
      },
    ],
    girls: "Girls",
    boys: "Boys",
    exploreHeader: "Change in first names over time",
    exploreExplanation:
      "Enter first names or click on the graphic lines to choose up to six names. You can also filter results by sex, canton or language region.",
    selectPlaceholder: "Search for a first name",
    note: "Note: Only the first 100 boys’ and girls’ first names are shown in the interactive graphic. During manual input, the first name must have been allocated at least twice in 2020 to appear.",
    linkheader: "More results",
    link: "<a href='https://www.pxweb.bfs.admin.ch/pxweb/fr/'>STAT-TAB – interactive tables (FSO) (admin.ch)</a>",
    source: "Source: FSO - BEVNAT",
    noresults: "No results found",
  },
  fr: {
    title: "Prénoms des nouveau-nés",
    intro:
      "Depuis plusieurs décennies, l’Office fédéral de la statistique publie les prénoms des nouveau-nés en Suisse, dans les cantons et les régions linguistiques. Chaque année, ces prénoms sont communiqués à l'OFS par les offices d'état civil, en même temps que les données relatives aux naissances vivantes survenues dans l'année.",
    top10header: "Top 10 des prénoms en 2020 en ",
    top10explanation:
      "Sélectionnez une région linguistique pour voir les prénoms des bébés les plus populaires dans cette région.",
    languages: [
      {
        value: "CH",
        label: "Suisse",
      },
      {
        value: "DD",
        label: "Suisse alémanique",
      },
      {
        value: "FF",
        label: "Suisse romande",
      },
      {
        value: "II",
        label: "Suisse italienne",
      },
      {
        value: "RR",
        label: "Suisse rhéto-romane",
      },
    ],
    girls: "Filles",
    boys: "Garçons",
    exploreHeader: "Evolution des prénoms dans le temps",
    exploreExplanation:
      "Saisissez des prénoms ou cliquez sur les lignes du graphique afin de sélectionner jusqu’à six prénoms. Vous pouvez également filtrer les résultats selon le sexe, le canton ou la région linguistique.",
    selectPlaceholder: "Recherche d’un prénom",
    note: "Note : Seuls les 100 premiers prénoms masculins et féminins sont affichés dans le graphique interactif. Lors de la saisie manuelle, il faut que le prénom ait été attribué au moins deux fois en 2020 pour apparaître.",
    linkheader: "Plus de résultats",
    link: "<a href='https://www.pxweb.bfs.admin.ch/pxweb/fr/'>STAT-TAB – tableaux interactifs (OFS) (admin.ch)</a>",
    source: "Source: FSO - BEVNAT",
    noresults: "Aucun résultat trouvé",
  },
  it: {
    title: "Nomi dei neonati",
    intro:
      "Da diversi decenni, l’Ufficio federale di statistica pubblica i nomi dei neonati in Svizzera, nei Cantoni e nelle regioni linguistiche. Ogni anno gli uffici dello stato civile comunicano all’UST tali nomi e i dati relativi ai nati vivi nell’arco dell’anno.",
    top10header: "Top 10 dei nomi più utilizzati nel 2020 in ",
    top10explanation:
      "Selezionare una regione linguistica per vedere i nomi di neonati più popolari nella regione.",
    languages: [
      {
        value: "CH",
        label: "Svizzera",
      },
      {
        value: "DD",
        label: "Svizzera tedesca",
      },
      {
        value: "FF",
        label: "Svizzera francese",
      },
      {
        value: "II",
        label: "Svizzera italiana",
      },
      {
        value: "RR",
        label: "Svizzera romancia",
      },
    ],
    girls: "Bambine",
    boys: "Bambini",
    exploreHeader: "Evoluzione dei nomi nel tempo",
    exploreExplanation:
      "Indicando o cliccando sulle righe del grafico è possibile selezionare fino a sei nomi. È inoltre possibile filtrare i risultati in base a sesso, Cantone o regione linguistica.",
    selectPlaceholder: "Cerca un nome",
    note: "N.B. Nel grafico interattivo sono rappresentati solo i 100 nomi maschili e femminili più utilizzati. Quando si inserisce manualmente un nome, questo deve essere stato assegnato almeno due volte nel 2020 per apparire sullo schermo.",
    linkheader: "Per visualizzare più risultati",
    link: "<a href='https://www.pxweb.bfs.admin.ch/pxweb/it/'>STAT-TAB – tabelle interattive (UST) (admin.ch)</a>",
    source: "Fonte: UST - BEVNAT",
    noresults: "Nessun risultato",
  },
  de: {
    title: "Vornamen der Neugeborenen",
    intro:
      "Seit mehreren Jahrzehnten publiziert das Bundesamt für Statistik (BFS) die Rangliste der Vornamen der Neugeborenen für die gesamte Schweiz sowie nach Kanton und nach Sprachregion. Die Vornamen werden dem BFS jährlich von den Zivilstandsämtern zusammen mit den Daten zu den Lebendgeburten gemeldet.",
    top10header: "Top 10 der Vornamen 2020 in der ",
    top10explanation:
      "Wählen Sie eine Sprachregion aus und entdecken Sie, welches die beliebtesten Vornamen sind.",
    languages: [
      {
        value: "CH",
        label: "Schweiz",
      },
      {
        value: "DD",
        label: "Deutschschweiz",
      },
      {
        value: "FF",
        label: "Französische Schweiz",
      },
      {
        value: "II",
        label: "Italienische Schweiz",
      },
      {
        value: "RR",
        label: "Rätoromanische Schweiz",
      },
    ],
    girls: "Mädchen",
    boys: "Knaben",
    exploreHeader: "Vornamen im Lauf der Zeit",
    exploreExplanation:
      "Geben Sie einen Vornamen ein oder klicken Sie auf die Linien in der Grafik und wählen Sie maximal sechs Vornamen aus. Es kann zudem nach Geschlecht, Kanton oder Sprachregion gefiltert werden.",
    selectPlaceholder: "Suche eines Vornamens",
    note: "Anmerkung: In der interaktiven Grafik werden die 100 beliebtesten weiblichen und männlichen Vornamen angezeigt. Bei der manuellen Suche sind ausschliesslich Namen zu finden, die 2020 mindestens zweimal vergeben wurden.",
    linkheader: "Weitere Ergebnisse",
    link: "<a href='https://www.pxweb.bfs.admin.ch/pxweb/de/'>STAT-TAB – interaktive Tabellen (BFS) (admin.ch)</a>",
    source: "Quelle: BFS - BEVNAT",
    noresults: "Keine Resultate gefunden",
  },
};
